/**
 * IDs for external features referenced in file_viewer/core.
 */
export const INFO_BLADE_PLUGIN_ID = 'info_blade';
export const TRANSCRIPT_BLADE_PLUGIN_ID = 'transcript_blade';
export const PDF_EDITOR_PLUGIN_ID = 'pdf_edit_plugin';
export const COMMENTS_PLUGIN_ID = 'comments';
export const FILE_ACTIVITY_PLUGIN_ID = 'file_activity';
export const AI_PLUGIN_ID = 'previews_ai_plugin';
export const PHOTO_EDITOR_PLUGIN_ID = 'photo_edit_plugin';
export const VIDEO_EDITOR_PLUGIN_ID = 'video_editor_overlay_plugin';
export const TEXT_DIFF_HIGHLIGHTER_PLUGIN = 'text_diff_highlighter_plugin';
export const TEXT_EDITOR_PLUGIN_ID = 'text_edit_plugin';
export const leftSidebarPluginIds = [INFO_BLADE_PLUGIN_ID, FILE_ACTIVITY_PLUGIN_ID];
const rightSidebarPluginIds = [
    TRANSCRIPT_BLADE_PLUGIN_ID,
    COMMENTS_PLUGIN_ID,
    AI_PLUGIN_ID,
];
const textHighlighterIds = [COMMENTS_PLUGIN_ID, TEXT_DIFF_HIGHLIGHTER_PLUGIN];
const videoEditorInitialActionStrings = [
    'rotateLeft',
    'rotateRight',
    'flipHorizontal',
    'flipVertical',
    'crop',
    'trim',
    'enhanceSpeech',
];
//# sourceMappingURL=types.preenvesnextjs.map
